export default {
  title: "Paiement à l'usage",
  subtitle: "Achetez des crédits selon vos besoins, aucun abonnement requis",
  calculation_title: "Calculs d'émissions de carbone",
  report_title: "Rapports",
  combo_title: "Forfaits combinés",
  combo_subtitle: "Économisez davantage avec nos forfaits combinés",
  select_quantity: "Sélectionnez la quantité",
  select_package: "Sélectionnez un forfait",
  total: "Total",
  calculation_credits: "Crédits de calcul",
  report_credits: "Crédits de rapport",
  credits: "crédits",
  price: "Prix",
  buy_now: "Acheter maintenant",
  starter_pack: "Pack Démarrage",
  professional_pack: "Pack Professionnel",
  enterprise_pack: "Pack Entreprise",
  save_x_percent: "Économisez {percent} %",
  note: "Les crédits que vous achetez n'expirent jamais.",
  expiry_note:
    "Vous pouvez les utiliser à tout moment. À l'avenir, des fonctionnalités optionnelles d'extension ou de conversion de crédits seront disponibles.",
  calculation_price: "Calculs d'émissions de carbone",
  report_price: "Rapports",
  calculation_price_dynamic: "{price} par calcul",
  report_price_dynamic: "{price} par rapport",
  benefits: "Avantages du paiement à l'usage",
  future_features: "Fonctionnalités à venir",
  future_features_desc:
    "Nous prévoyons d'introduire des extensions de crédits et des échanges optionnels ultérieurement. Aucune action n'est requise pour le moment.",
  extension_option_future: "Extension de crédits",
  extension_option_future_desc:
    "Prolongez la validité de vos crédits moyennant un petit frais (disponible dans une prochaine version).",
  credit_exchange_future: "Échange de crédits",
  credit_exchange_future_desc:
    "Échangez les crédits inutilisés ou expirés contre un accès d'essai dans les futures versions.",
  quantity: "Quantité",
  ladder_pricing: "Tarification progressive",
  unit: "unité",
  pay_per_use_benefit1: "Aucun abonnement requis",
  pay_per_use_benefit2: "Payez uniquement ce que vous utilisez",
  pay_per_use_benefit3: "Valable à vie",
};
